const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ?]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
};

export const customPortalInfoFields = [
  {
    id: "portal_link_timeout",
    label: "Customer Portal Link Timeout (Hours)",
    placeHolder: "Enter timeout hours",
    type: "text",
    // firstColmd:4,
    md: 6,
    inputProps: {
      maxLength: 3, // max 999 hours
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "otp_timeout",
    label: "Customer Portal OTP Timeout (Minutes)",
    placeHolder: "Enter OTP timeout",
    type: "text",
    // firstColmd:4,
    md: 6,
    inputProps: {
      maxLength: 2, // max 90 minutes
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "portal_session_timeout",
    label: "Customer Portal Session Timeout (Hours)",
    placeHolder: "Enter timeout hours",
    type: "text",
    // firstColmd:4,
    md: 6,
    inputProps: {
      maxLength: 3, // max 999 hours
    },
    patternAllowed: patternConstant?.NUMERIC,
    disabled: true, // Disable this field as it's not currently used
  },
];